import { TorneoListaBuenaFe, TorneoListaBuenaFeJSON } from '../TorneoListaBuenaFe/TorneoListaBuenaFe';
import { Jugador, JugadorJSON } from '../Jugador/Jugador';
export interface TorneoListaBuenaFeJugadorJSON {
  tlbfj_id: string;
  tlbfj_tlbfid: string;
  tlbfj_jugid: string;
  tlbfj_dorsal: number;
  torneoListaBuenaFe: TorneoListaBuenaFeJSON | null;
  jugador: JugadorJSON | null;
}

export class TorneoListaBuenaFeJugador {
  protected constructor(
    private id: string,
    private tlbfid: string,
    private jugid: string,
    private dorsal: number,
    private torneoListaBuenaFe: TorneoListaBuenaFe | null,
    private jugador: Jugador | null
  ) {}

  static createFrom(
    id: string,
    tlbfid: string,
    jugid: string,
    dorsal: number,
    torneoListaBuenaFe: TorneoListaBuenaFe | null,
    jugador: Jugador | null
  ) {
    return new this(id, tlbfid, jugid, dorsal, torneoListaBuenaFe, jugador);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: TorneoListaBuenaFeJugador) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TorneoListaBuenaFeJugadorJSON) {
    return TorneoListaBuenaFeJugador.createFrom(
      entity.tlbfj_id,
      entity.tlbfj_tlbfid,
      entity.tlbfj_jugid,
      entity.tlbfj_dorsal,
      entity.torneoListaBuenaFe ? TorneoListaBuenaFe.fromJSON(entity.torneoListaBuenaFe) : null,
      entity.jugador ? Jugador.fromJSON(entity.jugador) : null
    );
  }

  toJSON(): TorneoListaBuenaFeJugadorJSON {
    return {
      tlbfj_id: this.getId(),
      tlbfj_tlbfid: this.getTlbfid(),
      tlbfj_jugid: this.getJugid(),
      tlbfj_dorsal: this.getDorsal(),
      torneoListaBuenaFe: null,
      jugador: null,
    };
  }

  getId(): string {
    return this.id;
  }

  getTlbfid(): string {
    return this.tlbfid;
  }

  getJugid(): string {
    return this.jugid;
  }

  getDorsal(): number {
    return this.dorsal;
  }

  getTorneoListaBuenaFe(): TorneoListaBuenaFe | null {
    return this.torneoListaBuenaFe;
  }
  getJugador(): Jugador | null {
    return this.jugador;
  }
}
